import React from 'react';
import { SnapshotFrom } from 'xstate';
import { U } from 'ts-toolbelt';
import { Dialog } from '@hvcgroep/design-system';
import { useDialogHelpers } from '@uncinc/uncinc-react-kitchen-sink';
import { useTranslation } from 'react-i18next';
import { registrationDeskMachine } from '../../state-machine';

type ArrayElement<ArrayType extends readonly unknown[]> =
ArrayType extends readonly (infer ElementType)[] ? ElementType : never;

type Snapshot = SnapshotFrom<typeof registrationDeskMachine>;

interface Props {
  state: U.NonNullable<U.Exclude<ArrayElement<Parameters<Snapshot['matches']>>, 'form' | 'dialog'>['dialog']>;
  onConfirm: () => void;
  onCancel: () => void;
}

const ResetJourneyConfirmationDialog: React.FC<Props> = (props) => {
  const { state, onConfirm, onCancel } = props;

  const isDialogOpen = state !== 'off';

  const dialogRef = React.useRef<HTMLDivElement>(null);

  const { t } = useTranslation();

  const {
    dialogHelpersProps,
  } = useDialogHelpers({
    closeFunction: onCancel,
    // @ts-expect-error
    wrapperElement: dialogRef,
    isOpen: isDialogOpen,
  });

  if (!isDialogOpen) {
    return null;
  }

  const title = t('registration_desk.confirm_reset.warning');
  const labelId = 'reset_confirmation_dialog';
  const content = state === 'confirmJourneyClose' ? t('registration_desk.confirm_reset.content_on_journey_close') : t('registration_desk.confirm_reset.content_on_address_reset');
  const primaryButtonText = state === 'confirmJourneyClose' ? t('registration_desk.confirm_reset.close_journey') : t('registration_desk.confirm_reset.reset_address');
  const secondaryButtonText = t('registration_desk.confirm_reset.cancel');

  return (
    <Dialog
      {...dialogHelpersProps}
      wrapperRef={dialogRef}
      labelId={labelId}
      title={title}
      onCloseButtonClick={onCancel}
      primaryButton={{
        text: primaryButtonText,
        onClick: onConfirm,
      }}
      secondaryButton={{
        text: secondaryButtonText,
        onClick: onCancel,
      }}
    >
      <p>{content}</p>
    </Dialog>
  );
};

export default ResetJourneyConfirmationDialog;
